<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            <h1 class="headline black--text" v-html="`Peserta Non Dapodik`"></h1>
            <p>
              <b>Peserta Non Dapodik adalah</b> peserta yang ditambahkan daru unsur guru yang tidak terdata dari Dapodik
              untuk kebutuhan diklat moda luring
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnAdd="$allow('lpd-peserta-non-ptk.create')"
          :btnUpload="$allow('lpd-peserta-non-ptk.upload')"
          @add="onAdd"
          @upload="onUpload"
          @reload="onReload"
          @download="onDownload"
        >
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              Daftar Peserta Luring <b>{{ total }} </b>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <slot :item="item">
                <v-list three-line>
                  <v-list-item dense class="px-0">
                    <v-list-item-avatar color="primary">
                      <v-icon dark size="30">mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="12" md="3">
                          <div style="font-size: 16px" class="black--text mb-1">
                            <strong>{{ $getDeepObj(item, 'nama') || '-' }}</strong>
                          </div>
                          <span class="caption">NIK: </span>
                          <span>
                            {{ $getDeepObj(item, 'nik') || '-' }}
                          </span>
                        </v-col>
                        <v-col cols="12" md="3">
                          <span class="caption">Jenis Diklat</span>
                          <div style="font-size: 16px">
                            {{ $getDeepObj(item, 'm_diklat_paud.keterangan') || '-' }}
                          </div>
                        </v-col>
                        <v-col cols="12" md="3">
                          <span class="caption">Jenjang Diklat</span>
                          <div style="font-size: 16px">
                            {{ $getDeepObj(item, 'm_jenjang_diklat_paud.keterangan') || '-' }}
                          </div>
                          <span
                            :class="[
                              'caption',
                              !$getDeepObj(item, 'sertifikat_url') || !$getDeepObj(item, 'sk_instansi_url')
                                ? 'purple--text'
                                : 'success--text',
                            ]"
                          >
                            {{
                              !$getDeepObj(item, 'sertifikat_url') || !$getDeepObj(item, 'sk_instansi_url')
                                ? 'Belum Unggah Dokumen'
                                : 'Sudah Unggah Dokumen'
                            }}
                          </span>
                        </v-col>
                        <v-col cols="12" md="3">
                          <span class="caption">Unit Kerja</span>
                          <div style="font-size: 16px">
                            {{ $getDeepObj(item, 'sekolah.nama') || $getDeepObj(item, 'unit_kerja') || '-' }}
                          </div>
                          <div
                            v-if="$getDeepObj(item, 'sekolah.nama') || $getDeepObj(item, 'unit_kerja')"
                            :class="['caption', `${getColor(item.sekolah_id ? 2 : 5)}--text`]"
                          >
                            {{ item.sekolah_id ? 'Sekolah Dapodik' : 'Input Manual' }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action-text>
                      <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                    </v-list-item-action-text>
                  </v-list-item>
                </v-list>
              </slot>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>

    <base-modal-full
      ref="modal"
      colorBtn="primary"
      generalError
      :use-save="formulir.isValid"
      :title="formulir.title"
      @save="onSave"
    >
      <component
        ref="formulir"
        :is="formulir.component || 'FormPeserta'"
        :isEdit="formulir.isEdit"
        :initValue="formulir.initValue"
        :masters="masters"
        @validate="onValidate"
        @onStep="
          () => {
            formulir.isValid = false;
          }
        "
      />
    </base-modal-full>
    <popup-upload
      ref="uploader"
      :rules="{ format: 'xls', required: true }"
      format="XLXS/XLS"
      title="Data Peserta"
      @save="uploadSave"
    >
      <template v-slot:top>
        Anda dapat mengunduh template unggah peserta non dapodik
        <a class="blue--text" style="cursor: pointer" @click="unduhTemplate">Disini</a>
      </template>
    </popup-upload>
  </div>
</template>
<script>
import list from '@mixins/list';
import FormPeserta from './formulir/Peserta';
import FormInfo from './formulir/InfoPeserta';
import PopupUpload from '@components/popup/Upload';
import { mapActions, mapState } from 'vuex';
import actions from './actions';

export default {
  mixins: [list],
  components: { FormPeserta, FormInfo, PopupUpload },
  data() {
    return {
      formulir: {},
      actions: actions,
    };
  },
  created() {
    this.getMasters({
      name: [
        'm_propinsi',
        'm_kota',
        'm_kualifikasi',
        'm_golongan',
        'm_diklat_paud',
        'm_jenjang_diklat_paud',
        'm_guru_paud',
        'm_kualifikasi_paud',
      ].join(';'),
      filter: {
        0: {
          k_propinsi: {
            op: '<',
            val: 90,
          },
        },
      },
    });
  },
  computed: {
    ...mapState('master', ['masters']),

    labelTemplate() {
      return `<span class="black--text"> Unduh template peserta <a class="blue--text" href='https://files1.simpkb.id/berkas/paud/format_unggah_peserta_non_dapodik.xlsx' target='blank'>disini</a></span>`;
    },
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('peserta', [
      'fetch',
      'getDetail',
      'getInfoPeserta',
      'create',
      'update',
      'delete',
      'upload',
      'download',
    ]),

    onAdd() {
      this.$set(this.formulir, 'title', 'Tambah Peserta Non Dapodik');
      this.$set(this.formulir, 'component', 'FormPeserta');
      this.$set(this.formulir, 'isEdit', false);
      this.$set(this.formulir, 'isValid', false);
      this.$set(this.formulir, 'id', null);

      this.$set(this.formulir, 'initValue', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onEdit(item) {
      const { data } = await this.getInfoPeserta({ id: this.$getDeepObj(item, 'paud_peserta_nonptk_id') });

      this.$set(this.formulir, 'title', 'Ubah Peserta Non Dapodik');
      this.$set(this.formulir, 'component', 'FormPeserta');
      this.$set(this.formulir, 'isEdit', true);
      this.$set(this.formulir, 'isValid', false);
      this.$set(this.formulir, 'id', this.$getDeepObj(data, 'paud_peserta_nonptk_id'));

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'initValue', data);
      });
    },

    async onDetil(item) {
      const { data } = await this.getInfoPeserta({ id: this.$getDeepObj(item, 'paud_peserta_nonptk_id') });

      this.$set(this.formulir, 'title', 'Data Profil');
      this.$set(this.formulir, 'component', 'FormInfo');
      this.$set(this.formulir, 'isEdit', false);
      this.$set(this.formulir, 'isValid', false);
      this.$set(this.formulir, 'initValue', data);

      this.$refs.modal.open();
    },

    onValidate(sekolah) {
      this.$refs.modal.onValidate().then((valid) => {
        if (!this.$isObject(sekolah)) {
          this.$error('Silakan cek data unit kerja terlebih dahulu');
          return;
        }
        this.$set(this.formulir, 'isValid', valid);
        if (valid) this.$refs.formulir.next(valid);
      });
    },

    onSave() {
      const form = this.$refs.formulir.form || {};
      const formData = new FormData();
      const id = this.formulir.id || null;

      Object.keys(form).forEach((key) => {
        if (form[key]) {
          formData.append(key, form[key]);
        }
      });

      this[id ? 'update' : 'create']({ id: id, params: formData })
        .then(() => {
          this.$success(`Data peserta berhasil ${id ? 'Di ubah' : 'Ditambahkan'}`);
          this.$refs.modal.close();
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelete(data) {
      this.$confirm(`Apakan anda ingin menghapus peserta ${data.nama} berikut ?`, `Hapus Peserta`, {
        tipe: 'error',
        data: [],
      }).then(() => {
        this.delete({ id: this.$getDeepObj(data, 'paud_peserta_nonptk_id') }).then(() => {
          this.$success(`Peserta berhasil dihapus`);
          this.fetchData();
        });
      });
    },

    onUpload() {
      this.$refs.uploader.open();
    },

    uploadSave(data) {
      const formData = new FormData();
      for (let obj in data) {
        formData.append(obj, data[obj]);
      }

      const params = {
        params: formData,
      };

      this.upload(params)
        .then(({ data }) => {
          if (data && data.count && data.count.errors) {
            const error = Object.values(data.count.errors) || [];
            this.$refs.uploader.step = 1;
            this.$refs.uploader.errorFile.push(...error);
            return;
          }

          this.$refs.uploader.close();
          this.$success('Data Berhasil di unggah');
          this.fetchData();
        })
        .catch(() => {
          this.$error('Terdapat kesalahan saat mengunggah berkas, silakan periksa berkas Anda kemudian coba kembali!');
        });
    },

    unduhTemplate() {
      this.download().then((url) => {
        window.open(url);
      });
    },
  },
};
</script>
